<template>
  <div class="modal modal-result fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center modal-result__content">
        <button type="button" class="modal__close d-flex align-items-center justify-content-center" data-dismiss="modal">
          <svg-icon icon="close-remove"></svg-icon>
        </button>

        <div class="modal-result__title pb-3">{{title}}</div>
        <div class="modal-result__text pb-3">{{text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        title : null,
        text : null,
      }
    },
    mounted () {

    },
    methods : {
      cleanUp() {
        this.title = false
        this.text = false
      },
      setContent(title, text) {
        this.title = title
        this.text = text
      }
    },
  }
</script>
